import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';
import { POPUP_ZINDEX } from '../utils';

const propTypes = {
  right: PropTypes.number,
  left: PropTypes.number,
  top: PropTypes.number,
  position: PropTypes.string,
  visible: PropTypes.bool,
  parent: PropTypes.object,
  enableDyncmicPosition: PropTypes.bool,
  dynamicWidth: PropTypes.number,
  parentContainerWidth: PropTypes.number,
  offsetLeft: PropTypes.number,
  zIndex: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onOutsideClick: PropTypes.func
};

const defaultProps = {
  position: 'relative',
  enableDyncmicPosition: false,
  dynamicWidth: 250,
  parentContainerWidth: 620,
  className: '',
  visible: false
};

const PopupMenu = props => {
  const [isMenuVisible, setIsMenuVisible] = useState(props.visible);

  const context = useContext(ThemeContext);
  const theme = useTheme();
  const {
    enableDyncmicPosition,
    right,
    left,
    parent,
    dynamicWidth,
    parentContainerWidth,
    visible
  } = props;

  let popupmenu;
  if (theme && theme.popupmenu) {
    popupmenu = theme.popupmenu;
  } else {
    popupmenu = context.theme.popupmenu;
  }
  const { bgColor } = popupmenu;
  const popupMenuRef = React.createRef();

  const handleOutsideClick = (e) => {
    const { target } = e;
    if (popupMenuRef &&
      popupMenuRef.current &&
      visible &&
      parent &&
      parent.current &&
      !popupMenuRef.current.contains(target) &&
      !parent.current.contains(target)
    ) {
      props.onOutsideClick();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick, false);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick, false);
    };
  });

  useEffect(() => {
    if (isMenuVisible !== props.visible) {
      setIsMenuVisible(props.visible);
    }
  }, [props.visible]);

  const styles = StyleSheet.create({
    popupMenu: {
      top: `${props.top}px`,
      // display: visible ? 'block' : 'none',
      // display: isMenuVisible ? 'block' : 'none',
      position: `${props.position}`,
      zIndex: props.zIndex ? props.zIndex : POPUP_ZINDEX,
      isolation: 'isolate',
      boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.5)'
    }
  });

  const menuStyles = {};
  if (enableDyncmicPosition) {
    if (parent && parent.current) {
      const parentBounds = parent.current.getBoundingClientRect();
      if ((parentBounds.left + dynamicWidth) <= parentContainerWidth) {
        styles.left = '0px';
      } else {
        styles.right = '0px';
      }
    }
  } else {
    menuStyles.right = right ? `${right}px` : null;
    menuStyles.left = left ? `${left}px` : null;
  }

  return (
    <div
      ref={popupMenuRef}
      className={`popup-menu ${props.className} ${css(styles.popupMenu)}`}
      style={{
        ...menuStyles,
        display: isMenuVisible ? 'block' : 'none',
      }}
    >
      {props.children}
    </div>
  );
};

PopupMenu.propTypes = propTypes;
PopupMenu.defaultProps = defaultProps;

export { PopupMenu };
